<template>
  <div v-loading="loading" class="customer-analysis-panel">
    <template v-if="analysis.customerId">
      <el-row :gutter="12" class="score-row">
        <el-col v-for="score in scoreCards" :key="score.label" :xs="12" :sm="6">
          <div class="score-card" :class="score.className">
            <div class="score-value">{{ score.value }}</div>
            <div class="score-label">{{ score.label }}</div>
          </div>
        </el-col>
      </el-row>

      <el-alert :title="analysis.nextAction || '暂无建议动作'" type="info" :closable="false" show-icon class="action-alert"/>

      <div class="section-title">风险与机会</div>
      <div v-if="analysis.riskList && analysis.riskList.length" class="risk-list">
        <div v-for="risk in analysis.riskList" :key="risk.type" class="risk-item">
          <el-tag :type="riskTagType(risk.level)" size="small">{{ risk.name }}</el-tag>
          <span class="risk-reason">{{ risk.reason }}</span>
          <span class="risk-action">建议：{{ risk.action }}</span>
        </div>
      </div>
      <el-empty v-else description="当前未触发经营风险" :image-size="72"/>

      <div class="section-title">经营数据</div>
      <el-descriptions :column="3" border>
        <el-descriptions-item label="经营分层">{{ analysis.segmentName }}</el-descriptions-item>
        <el-descriptions-item label="负责人">{{ analysis.managerName || '未分配' }}</el-descriptions-item>
        <el-descriptions-item label="最近跟进">{{ analysis.lastFollowTime || '暂无' }}</el-descriptions-item>
        <el-descriptions-item label="近12个月合同额">{{ money(analysis.totalContractAmount) }} 元</el-descriptions-item>
        <el-descriptions-item label="近12个月回款">{{ money(analysis.receivedAmount) }} 元</el-descriptions-item>
        <el-descriptions-item label="逾期回款">{{ money(analysis.overdueAmount) }} 元</el-descriptions-item>
        <el-descriptions-item label="在途商机">{{ analysis.openBusinessCount || 0 }} 个</el-descriptions-item>
        <el-descriptions-item label="在途商机金额">{{ money(analysis.openBusinessAmount) }} 元</el-descriptions-item>
        <el-descriptions-item label="停滞商机">{{ analysis.stalledBusinessCount || 0 }} 个</el-descriptions-item>
        <el-descriptions-item label="待处理服务">{{ analysis.pendingServiceCount || 0 }} 个</el-descriptions-item>
        <el-descriptions-item label="待交付">{{ analysis.pendingDeliveryCount || 0 }} 个</el-descriptions-item>
        <el-descriptions-item label="标准产品映射">{{ analysis.standardProductCount || 0 }}/{{ analysis.compositionCount || 0 }}</el-descriptions-item>
      </el-descriptions>
    </template>
    <el-empty v-else-if="!loading" description="暂无客户分析数据"/>
  </div>
</template>

<script>
import { queryCustomerAnalysisDetail } from '@/api/crm/customerAnalysis'
import { amountFormat } from '@/utils/index'

export default {
  name: 'CustomerAnalysisPanel',
  props: {
    customerId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      loading: false,
      analysis: {}
    }
  },
  computed: {
    scoreCards() {
      return [
        { label: '客户价值', value: this.analysis.valueScore || 0, className: 'is-value' },
        { label: '健康度', value: this.analysis.healthScore || 0, className: 'is-health' },
        { label: '增长潜力', value: this.analysis.growthScore || 0, className: 'is-growth' },
        { label: '数据完整度', value: this.analysis.dataCompleteness || 0, className: 'is-complete' }
      ]
    }
  },
  mounted() {
    this.refresh()
  },
  watch: {
    customerId(value, oldValue) {
      if (value && value !== oldValue) {
        this.refresh()
      }
    }
  },
  methods: {
    refresh() {
      if (!this.customerId) return
      this.loading = true
      queryCustomerAnalysisDetail({ customerId: this.customerId }).then(response => {
        this.analysis = response.data || {}
      }).finally(() => {
        this.loading = false
      })
    },
    money(value) {
      return amountFormat(Number(value || 0))
    },
    riskTagType(level) {
      if (level === 'HIGH') return 'danger'
      if (level === 'MEDIUM') return 'warning'
      return 'info'
    }
  }
}
</script>

<style scoped>
.customer-analysis-panel {
  min-height: 360px;
  padding: 10px 4px 20px;
}
.score-row {
  margin-bottom: 16px;
}
.score-card {
  padding: 18px 12px;
  border-radius: 6px;
  color: #fff;
  text-align: center;
  background: #409eff;
}
.score-card.is-health { background: #67c23a; }
.score-card.is-growth { background: #e6a23c; }
.score-card.is-complete { background: #909399; }
.score-value { font-size: 28px; font-weight: 600; line-height: 34px; }
.score-label { margin-top: 4px; font-size: 13px; opacity: .9; }
.action-alert { margin-bottom: 18px; }
.section-title {
  margin: 18px 0 10px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
  color: #303133;
  font-weight: 600;
}
.risk-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
  line-height: 24px;
}
.risk-reason { flex: 1; color: #606266; }
.risk-action { flex: 1.2; color: #909399; }
</style>
